// This represent a very simple/raw summation, just adding the values together, which have already been set up to be resolved in this manner.
export const fragSamplerSummation = `
precision mediump float;

uniform sampler2D uSampler0;
uniform sampler2D uSampler1;
varying vec2 outTexCoord;

void main ()
{
  vec4 colour1 = texture2D(uSampler0, outTexCoord);
  vec4 colour2 = texture2D(uSampler1, outTexCoord);
  gl_FragColor = colour1 + colour2;
}
`;
